export default __webpack_public_path__ + "img/27039f0024f046178db0db306d646fde.svg";